<template>
  <div>
    <div class="month">{{ month }}</div>
    <div class="day">{{ day }}</div>
    <div class="week">{{ week }}</div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    date: Number
  },
  data: function() {
    return {
      month: "7月",
      day: "12",
      week: "週二"
    };
  },
  mounted() {
    const date = dayjs(this.date);
    this.day = date.date();
    this.month = `${date.month() + 1}月`;
    const dayOfWeek = ["", "一", "二", "三", "四", "五", "六", "日"];
    this.week = `週${dayOfWeek[date.day()]}`;
  }
};
</script>

<style lang="scss" scoped>
div {
  color: #595959;
  font-weight: bold;
}
.month {
  font-size: 16px;
}
.day {
  font-size: 24px;
}
.week {
  font-size: 16px;
}
</style>
